function setUpFormValidation() {
  const signUpForm = document.querySelector("#wm_sign_up_form"),
    checks = document.querySelectorAll("#user_profile input[type='checkbox']");
  for (const c of checks) {
    c.addEventListener("change", function() {
      wm.validateUserProfile();
    });
  }
  for (const evt of ["change", "input"]) {
    signUpForm.addEventListener(evt, function() {
      wm.refreshSignUpForm(signUpForm);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setUpFormValidation();
});
